import { MockDb } from '../../../../mockDb';

const db = new MockDb('inventory', [
  { id: 1, name: "Admission Fee", code: "INV-001", upc: "", hsnSac: "", qty: 0.00, groupName: "Products", status: "Active", createdDate: "Apr 10, 2026" },
  { id: 2, name: "Application Fee", code: "INV-002", upc: "", hsnSac: "", qty: 0.00, groupName: "Products", status: "Active", createdDate: "Apr 12, 2026" },
  { id: 3, name: "Courseware_Fee", code: "INV-003", upc: "", hsnSac: "", qty: 0.00, groupName: "Products", status: "Active", createdDate: "Apr 14, 2026" },
  { id: 4, name: "Dell Laptop", code: "INV-004", upc: "", hsnSac: "4562", qty: 1.00, groupName: "Products", status: "Active", createdDate: "Apr 16, 2026" },
  { id: 5, name: "Introduction to Physics", code: "INV-005", upc: "", hsnSac: "", qty: 0.00, groupName: "Products", status: "Active", createdDate: "Apr 18, 2026" },
  { id: 6, name: "IV-A", code: "INV-006", upc: "", hsnSac: "", qty: 0.00, groupName: "Services", status: "Active", createdDate: "Apr 20, 2026" },
  { id: 7, name: "Monthly Transport Fee", code: "INV-007", upc: "", hsnSac: "", qty: 0.00, groupName: "Products", status: "Active", createdDate: "Apr 22, 2026" },
  { id: 8, name: "Monthly Tuition Fee", code: "INV-008", upc: "", hsnSac: "", qty: 0.00, groupName: "Products", status: "Active", createdDate: "Apr 24, 2026" },
  { id: 9, name: "Notebook", code: "INV-009", upc: "", hsnSac: "", qty: -15.00, groupName: "Raw-material", status: "Active", createdDate: "Apr 26, 2026" },
  { id: 10, name: "notes", code: "INV-010", upc: "", hsnSac: "", qty: 13.00, groupName: "Services", status: "Active", createdDate: "Apr 28, 2026" },
  { id: 11, name: "Others fee", code: "INV-011", upc: "", hsnSac: "", qty: 0.00, groupName: "Products", status: "Active", createdDate: "May 02, 2026" },
  { id: 12, name: "Out of pocket expenses", code: "INV-012", upc: "", hsnSac: "", qty: 0.00, groupName: "", status: "Active", createdDate: "May 04, 2026" },
  { id: 13, name: "Pen", code: "INV-013", upc: "", hsnSac: "", qty: 174.00, groupName: "Products", status: "Active", createdDate: "May 06, 2026" },
  { id: 14, name: "Quarterly Transport Fee", code: "INV-014", upc: "", hsnSac: "", qty: 0.00, groupName: "Products", status: "Active", createdDate: "May 08, 2026" },
  { id: 15, name: "Rate difference", code: "INV-015", upc: "", hsnSac: "", qty: 1.00, groupName: "Products", status: "Active", createdDate: "May 10, 2026" },
  { id: 16, name: "Security Deposit", code: "INV-016", upc: "", hsnSac: "", qty: 0.00, groupName: "Products", status: "Active", createdDate: "May 12, 2026" },
  { id: 17, name: "Term Fee", code: "INV-017", upc: "", hsnSac: "", qty: 0.00, groupName: "Services", status: "Active", createdDate: "May 14, 2026" },
  { id: 18, name: "tezerp", code: "INV-018", upc: "", hsnSac: "711319", qty: -1.00, groupName: "Products", status: "Active", createdDate: "May 16, 2026" },
  { id: 19, name: "Tuition_Fee", code: "INV-019", upc: "", hsnSac: "", qty: 0.00, groupName: "Products", status: "Active", createdDate: "May 18, 2026" },
  { id: 20, name: "VII STD", code: "INV-020", upc: "", hsnSac: "", qty: 0.00, groupName: "Services", status: "Active", createdDate: "May 20, 2026" }
]);

export async function listInventoryItems(params = {}) {
  await new Promise(r => setTimeout(r, 100));
  let list = db.getAll();
  
  if (params.viewMode === 'active') {
    list = list.filter(item => item.status === 'Active');
  } else if (params.viewMode === 'archived') {
    list = list.filter(item => item.status !== 'Active');
  }

  if (params.searchText) {
    const q = params.searchText.toLowerCase().trim();
    list = list.filter(item => 
      (item.name && item.name.toLowerCase().includes(q)) || 
      (item.code && item.code.toLowerCase().includes(q)) ||
      (item.upc && item.upc.toLowerCase().includes(q)) ||
      (item.hsnSac && item.hsnSac.toLowerCase().includes(q)) ||
      (item.groupName && item.groupName.toLowerCase().includes(q))
    );
  }

  return list;
}

export async function getInventoryItemDetail(itemId) {
  await new Promise(r => setTimeout(r, 100));
  return db.get(itemId);
}

export async function createInventoryItem(payload) {
  await new Promise(r => setTimeout(r, 100));
  return db.create(payload);
}

export async function updateInventoryItem(itemId, payload) {
  await new Promise(r => setTimeout(r, 100));
  return db.update(itemId, payload);
}

export async function archiveInventoryItem(itemId) {
  await new Promise(r => setTimeout(r, 100));
  return db.archive(itemId);
}

export async function deleteInventoryItem(itemId) {
  await new Promise(r => setTimeout(r, 100));
  return db.delete(itemId);
}
